	$(document).foundation();

$('a#fiction').click(function() {
  $('.non-fiction, .sports, .poetry, .pop-culture').slideUp('slow');
  $('.fiction').slideToggle('slow');
})

$('a#non-fiction').click(function() {
  $('.fiction, .sports, .poetry, .pop-culture').slideUp('slow');
  $('.non-fiction').slideToggle('slow');
})

$('a#poetry').click(function() {
  $('.non-fiction, .sports, .fiction, .pop-culture').slideUp('slow');
  $('.poetry').slideToggle('slow');
})

$('a#sports').click(function() {
  $('.non-fiction, .fiction, .poetry, .pop-culture').slideUp('slow');
  $('.sports').slideToggle('slow');
})

$('a#pop-culture').click(function() {
  $('.non-fiction, .sports, .poetry, .fiction').slideUp('slow');
  $('.pop-culture').slideToggle('slow');
})

$(document).on('opened.fndtn.reveal', '[data-reveal]', function () {
  $('body').css('overflow','hidden');
  $('#search-modal-input').focus();
});

$(document).on('closed.fndtn.reveal', '[data-reveal]', function () {
  $('body').css('overflow','scroll');
});

  $('a.close-reveal-modal').click(function() {
    $('#search-modal').hide();
  })

jQuery(function($){
  
  $('ul.tabs').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    $(this).find('a').click(function(e){
      active.removeClass('active');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  });
  
      $('.content.frontpage-fiction').addClass('active');

    
  $('#panel1').click(function() {
    $('.content').removeClass('active');
    $('.content.frontpage-fiction').addClass('active');
  })
  
  $('#panel2').click(function() {
    $('.content').removeClass('active');
    $('.content.frontpage-poetry').addClass('active');
  })
    
   $('#panel3').click(function() {
    $('.content').removeClass('active');
    $('.content.frontpage-mystery').addClass('active');
  })
      
  $('#panel4').click(function() {
    $('.content').removeClass('active');
    $('.content.frontpage-nonfiction').addClass('active');
  })
        
  $('#panel5').click(function() {
    $('.content').removeClass('active');
    $('.content.frontpage-bio').addClass('active');
  })
  
   $('#panel6').click(function() {
    $('.content').removeClass('active');
    $('.content.frontpage-sports').addClass('active');
  })
   
    $('#panel7').click(function() {
    $('.content').removeClass('active');
    $('.content.frontpage-popculture').addClass('active');
  })


  
  $('.hero-slider').slick({
    dots: true,
    autoplay: true,
    autoplaySpeed: 8000,
    fade: true
  });

  $('.collection-slider').slick({
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 7,

    variableWidth: true,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          autoplay: true,
          lazyLoad: 'ondemand',
          arrows: true,
          centerMode: true,
          centerPadding: '0',
          slidesToShow: 5
        }
      },
      {
        breakpoint: 642,
        settings: {
          autoplay: true,
          lazyLoad: 'ondemand',
          arrows: false,
          centerMode: true,
          centerPadding: '0',
          slidesToShow: 3
        }
      }
    ]
  });

  $('.related-slider').slick({
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 6,
    autoplay: false,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          autoplay: true,
          lazyLoad: 'ondemand',
          arrows: false,
          centerMode: true,
          centerPadding: '0',
          slidesToShow: 3
        }
      },
      {
        breakpoint: 642,
        settings: {
          autoplay: true,
          lazyLoad: 'ondemand',
          arrows: false,
          centerMode: true,
          centerPadding: '0',
          autoplay: true,
          slidesToShow: 1
        }
      }
    ]
  });

  var ecwtweets = {
    "id": '569941708708655104',
    "domId": '',
    "maxTweets": 3,
    "enableLinks": true,
    "showUser": false,
    "showTime": true,
    "dateFunction": '',
    "showRetweet": false,
    "customCallback": handleTweets,
    "showInteraction": true
  };

  function handleTweets(tweets){
      var x = tweets.length;
      var n = 0;
      var element = document.getElementById('twitter');
      var html = '<ul class="tweets small-block-grid-1 medium-block-grid-3 large-block-grid-1">';
      while(n < x) {
        html += '<li>' + tweets[n] + '</li>';
        n++;
      }
      html += '</ul>';
      element.innerHTML = html;
  }
  twitterFetcher.fetch(ecwtweets);
  
});



